import { useParams } from "react-router-dom";

export default function SettlementDetail() {
  const params = useParams();

  const orderNo = params.id;
  return <></>;
}
